
import { reactive } from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "RegistrationPrivacyPolicyData",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({      
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "RegistrierungBenutzer",
      page: "RegistrierungDatenschutz",      
      remoteId: "",
    });

  return {
      request,
    };
  }
};
